import { MetaPagination } from "@/models/general";
import { CampaignModule } from "@/store/campaign";
import { cloneDeep } from "lodash";

const RouterHelper = {
  cleanPaginations(name: string): void {
    if (["campaigns", "edit-campaign"].includes(name) === false) {
      CampaignModule.setPagination(new MetaPagination());
    }
  },
};

export default RouterHelper;
